import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  LocationListComponent,
  LocationDetailComponent,
  LocationCreateComponent,
  LocationEditComponent,
} from './pages';
import {
  WarehouseListComponent,
  WarehouseCreateComponent,
  WarehouseEditComponent,
  WarehouseDetailComponent,
} from './pages/warehouses';
import {
  StoreListComponent,
  StoreCreateComponent,
  StoreEditComponent,
  StoreDetailComponent,
} from './pages/stores';
import {
  UbicacionListComponent,
  UbicacionCreateComponent,
  UbicacionEditComponent,
  UbicacionDetailComponent,
} from './pages/ubicaciones';
import { UbicacionBatchCreateComponent } from './pages';
import { canMatchFn } from '@kanzi-apes/kanzi-auth';

const routes: Routes = [
  // ==================== WAREHOUSES ROUTES (NEW) ====================
  {
    path: 'warehouses',
    children: [
      {
        path: 'list',
        component: WarehouseListComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'create',
        component: WarehouseCreateComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'detail/:id',
        component: WarehouseDetailComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'edit/:id',
        component: WarehouseEditComponent,
        canActivate: [canMatchFn],
      },
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
    ],
  },

  // ==================== STORES ROUTES (NEW) ====================
  {
    path: 'stores',
    children: [
      {
        path: 'list',
        component: StoreListComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'create',
        component: StoreCreateComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'detail/:id',
        component: StoreDetailComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'edit/:id',
        component: StoreEditComponent,
        canActivate: [canMatchFn],
      },
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
    ],
  },

  // ==================== UBICACIONES ROUTES (NEW) ====================
  {
    path: 'ubicaciones',
    children: [
      {
        path: 'list',
        component: UbicacionListComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'create',
        component: UbicacionCreateComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'batch-create',
        component: UbicacionBatchCreateComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'detail/:id',
        component: UbicacionDetailComponent,
        canActivate: [canMatchFn],
      },
      {
        path: 'edit/:id',
        component: UbicacionEditComponent,
        canActivate: [canMatchFn],
      },
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
    ],
  },

  // ==================== LEGACY ROUTES (TO DEPRECATE) ====================
  // TODO: Marcar como @deprecated en FASE 4
  {
    path: 'list',
    component: LocationListComponent,
    canActivate: [canMatchFn],
  },
  {
    path: 'create',
    component: LocationCreateComponent,
    canActivate: [canMatchFn],
  },
  {
    path: 'detail/:id',
    component: LocationDetailComponent,
    canActivate: [canMatchFn],
  },
  {
    path: 'edit/:id',
    component: LocationEditComponent,
    canActivate: [canMatchFn],
  },
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LocationRoutingModule {}
